import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import apiClient from "../../services/apiClient";
import { getCookie } from "../../utils/cookies";
import toast from "../../utils/toast";

const MONTH_NAMES = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

function formatDateForApi(dateStr) {
  if (!dateStr) return "";
  const [year, month, day] = dateStr.split("-");
  return `${day}-${MONTH_NAMES[Number(month) - 1]}-${year}`;
}

const PAGE_SIZE = 10;

const WALLET_SUBTEXT = {
  Affiliate: "Sponsor income credited instantly",
  Activation: "Available for activation or payout",
};

function Pagination({ currentPage, totalItems, pageSize, onPageChange }) {
  const totalPages = Math.max(1, Math.ceil(totalItems / pageSize));
  if (totalPages <= 1) return null;

  return (
    <div className="pagination-row">
      <button
        className="btn-sm"
        disabled={currentPage === 1}
        onClick={() => onPageChange(currentPage - 1)}
      >
        Prev
      </button>
      <span className="pagination-info">
        Page {currentPage} of {totalPages}
      </span>
      <button
        className="btn-sm"
        disabled={currentPage === totalPages}
        onClick={() => onPageChange(currentPage + 1)}
      >
        Next
      </button>
    </div>
  );
}

export default function Wallets() {
  const navigate = useNavigate();
  const [isAccountActive, setIsAccountActive] = useState(false);
  const [isBalanceData, setBalanceData] = useState();
  const [isTransactionHistoryData, setTransactionHistoryData] = useState();
  const [isTxnLoading, setTxnLoading] = useState(true);

  const [txnFromDate, setTxnFromDate] = useState("");
  const [txnToDate, setTxnToDate] = useState("");
  const [txnPage, setTxnPage] = useState(1);

  const [isTransferModalOpen, setIsTransferModalOpen] = useState(false);
  const [activeTransferWallet, setActiveTransferWallet] = useState(null);
  const [transferToUserId, setTransferToUserId] = useState("");
  const [transferAmount, setTransferAmount] = useState("");
  const [transferRemark, setTransferRemark] = useState("");
  const [isTransferSubmitting, setIsTransferSubmitting] = useState(false);
  const [recipientName, setRecipientName] = useState("");
  const [isRecipientLoading, setIsRecipientLoading] = useState(false);
  const [recipientNotFound, setRecipientNotFound] = useState(false);

  const [isTransferToUserModalOpen, setIsTransferToUserModalOpen] =
    useState(false);
  const [activeTransferToUserWallet, setActiveTransferToUserWallet] =
    useState(null);
  const [transferToUserRecipientId, setTransferToUserRecipientId] =
    useState("");
  const [transferToUserAmount, setTransferToUserAmount] = useState("");
  const [transferToUserRemark, setTransferToUserRemark] = useState("");
  const [isTransferToUserSubmitting, setIsTransferToUserSubmitting] =
    useState(false);
  const [transferToUserRecipientName, setTransferToUserRecipientName] =
    useState("");
  const [
    isTransferToUserRecipientLoading,
    setIsTransferToUserRecipientLoading,
  ] = useState(false);
  const [
    transferToUserRecipientNotFound,
    setTransferToUserRecipientNotFound,
  ] = useState(false);

  const [isPayoutModalOpen, setIsPayoutModalOpen] = useState(false);
  const [activePayoutWallet, setActivePayoutWallet] = useState(null);
  const [payoutBankAccount, setPayoutBankAccount] = useState("");
  const [payoutAmount, setPayoutAmount] = useState("");
  const [payoutMode, setPayoutMode] = useState("IMPS");

  const [isSettlementModalOpen, setIsSettlementModalOpen] = useState(false);
  const [settlementIfsc, setSettlementIfsc] = useState("");
  const [settlementBank, setSettlementBank] = useState("");
  const [settlementBranchName, setSettlementBranchName] = useState("");
  const [settlementAccountNumber, setSettlementAccountNumber] = useState("");
  const [settlementAccountHolderName, setSettlementAccountHolderName] =
    useState("");
  const [bankAccounts, setBankAccounts] = useState([]);
  const [operatorList, setOperatorList] = useState([]);
  const [settlementBankId, setSettlementBankId] = useState("");
  const [isAddingBank, setIsAddingBank] = useState(false);
  const [bankMasterList, setBankMasterList] = useState([]);
  const [isTransferringMoney, setIsTransferringMoney] = useState(false);
  const [isDeletingBank, setIsDeletingBank] = useState(false);
  const [accountPendingDelete, setAccountPendingDelete] = useState(null);

  const userData = JSON.parse(getCookie("userData") || "{}");

  useEffect(() => {
    fetchBalanceData();
    fetchTransactionHistory(true);
    fetchAccountStatus();
  }, []);

  const fetchAccountStatus = async () => {
    try {
      const userData = JSON.parse(getCookie("userData") || "{}");
      const res = await apiClient.post("/Dashboard/MataMaskDashboard", {
        appid: "ROUNDPAYAPPID13APR20191351",
        imei: "d593bdd26dfbea56",
        loginTypeID: 1,
        regKey: "",
        serialNo: "d593bdd26dfbea56",
        session: getCookie("session") || "",
        sessionID: getCookie("sessionID") || "",
        userID: userData.userID || "",
        version: "1.0",
      });

      if (res.statuscode == 1) {
        setIsAccountActive(res.data?.isTopup === true);
      }
    } catch (err) {
      console.log("error", err);
    }
  };

  const fetchBalanceData = async () => {
    try {
      const userData = JSON.parse(getCookie("userData") || "{}");

      const res = await apiClient.post("/App/v2/GetBalance", {
        paymentID: 0,
        ID: 0,
        IsB2C: false,
        TID: 0,
        appid: "ROUNDPAYAPPID13APR20191351",
        id: 0,
        imei: "d593bdd26dfbea56",
        loginTypeID: 1,
        regKey: "",
        serialNo: "d593bdd26dfbea56",
        session: getCookie("session") || "",
        sessionID: getCookie("sessionID") || "",
        uid: 0,
        userID: userData.userID || "",
        version: "1.0",
      });

      if (res.statuscode == 1) {
        setBalanceData(res);
      }
    } catch (err) {
      console.log("error", err);
    }
  };

  function formatAmount(amount) {
    const num = Number(amount) || 0;
    return `₹${num.toLocaleString("en-IN", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}`;
  }

  function hasWithdrawalType(wallet) {
    return (
      Array.isArray(wallet?.allowedWithdrawalType) &&
      wallet.allowedWithdrawalType.length > 0
    );
  }

  const balanceData = isBalanceData?.balanceData || [];

  const activeWallets = balanceData.filter(
    (w) =>
      w.isWithdrawal === true ||
      (w.allowedWallet?.length || 0) > 0 ||
      (w.allowedWithdrawalType?.length || 0) > 0,
  );

  function getSelfTransferTarget(wallet) {
    if (
      wallet?.walletTransferType === 1 &&
      wallet?.isWithdrawal === true &&
      hasWithdrawalType(wallet)
    ) {
      return wallet.allowedWallet?.[0] || null;
    }
    return null;
  }

  function getRealtimeBankInfo(wallet) {
    if (wallet?.isWithdrawal !== true) return null;
    return (
      wallet?.allowedWithdrawalType?.find(
        (t) => t.serviceName === "RealTime Bank" && t.isActive,
      ) || null
    );
  }

  function getWalletToWalletInfo(wallet) {
    return (
      wallet?.allowedWithdrawalType?.find(
        (t) => t.serviceName === "Wallet TO Wallet" && t.isActive,
      ) || null
    );
  }

  const transferAllowedWalletInfo = activeTransferWallet?.allowedWallet?.[0];
  const transferIsSelfTransfer = activeTransferWallet?.walletTransferType === 1;
  const transferServiceInfo = getWalletToWalletInfo(activeTransferWallet);

  const payoutServiceInfo = getRealtimeBankInfo(activePayoutWallet);

  const transferToUserServiceInfo = getWalletToWalletInfo(
    activeTransferToUserWallet,
  );

  const payoutModes = operatorList.filter(
    (op) => op.opTypeName === "RealTime Bank" && op.isActive,
  );
  const selectedPayoutOperator = payoutModes.find(
    (mode) => mode.name === payoutMode,
  );

  function openTransferModal(wallet) {
    setActiveTransferWallet(wallet);
    setTransferToUserId(
      wallet?.walletTransferType === 1 ? String(userData.userID || "") : "",
    );
    setIsTransferModalOpen(true);
  }

  function closeTransferModal() {
    setIsTransferModalOpen(false);
    setActiveTransferWallet(null);
    setTransferToUserId("");
    setTransferAmount("");
    setTransferRemark("");
    setRecipientName("");
    setRecipientNotFound(false);
  }

  function openTranferToUserModal(wallet) {
    setActiveTransferToUserWallet(wallet);
    setTransferToUserRecipientId("");
    setTransferToUserAmount("");
    setTransferToUserRemark("");
    setTransferToUserRecipientName("");
    setTransferToUserRecipientNotFound(false);
    setIsTransferToUserModalOpen(true);
  }

  function closeTranferToUserModal() {
    setIsTransferToUserModalOpen(false);
    setActiveTransferToUserWallet(null);
    setTransferToUserRecipientId("");
    setTransferToUserAmount("");
    setTransferToUserRemark("");
    setTransferToUserRecipientName("");
    setTransferToUserRecipientNotFound(false);
  }

  function openPayoutModal(wallet) {
    setActivePayoutWallet(wallet);
    setIsPayoutModalOpen(true);
    fetchOperatorList();
    fetchBankList();
  }

  function closePayoutModal() {
    setIsPayoutModalOpen(false);
    setActivePayoutWallet(null);
    setPayoutBankAccount("");
    setPayoutAmount("");
    setPayoutMode("IMPS");
  }

  function openSettlementModal() {
    setIsSettlementModalOpen(true);
    fetchBankList();
    ChooseBankOptionsToSave();
  }

  function closeSettlementModal() {
    setIsSettlementModalOpen(false);
    setSettlementIfsc("");
    setSettlementBank("");
    setSettlementBankId("");
    setSettlementBranchName("");
    setSettlementAccountNumber("");
    setSettlementAccountHolderName("");
  }

  const fetchUserDetailById = async (recipientUserId) => {
    setIsRecipientLoading(true);
    try {
      const userData = JSON.parse(getCookie("userData") || "{}");

      const res = await apiClient.post("/FindUserDetailsById", {
        Request: recipientUserId,
        appSession: {
          ID: 0,
          IsB2C: false,
          TID: 0,
          appid: "ROUNDPAYAPPID13APR20191351",
          id: 0,
          imei: "d593bdd26dfbea56",
          loginTypeID: 1,
          regKey: "",
          serialNo: "d593bdd26dfbea56",
          session: getCookie("session") || "",
          sessionID: getCookie("sessionID") || "",
          uid: 0,
          userID: userData.userID || "",
          version: "1.0",
        },
      });

      if (res.statuscode == 1) {
        setRecipientName(res.name || "");
        setRecipientNotFound(false);
      } else {
        setRecipientName("");
        setRecipientNotFound(true);
      }
    } catch (err) {
      console.log("error", err);
      setRecipientName("");
      setRecipientNotFound(true);
    } finally {
      setIsRecipientLoading(false);
    }
  };

  useEffect(() => {
    if (!String(transferToUserId).trim()) {
      setRecipientName("");
      setRecipientNotFound(false);
      return;
    }

    const timer = setTimeout(() => {
      fetchUserDetailById(String(transferToUserId));
    }, 500);

    return () => clearTimeout(timer);
  }, [transferToUserId]);

  const fetchTransferToUserRecipient = async (recipientUserId) => {
    setIsTransferToUserRecipientLoading(true);
    try {
      const userData = JSON.parse(getCookie("userData") || "{}");

      const res = await apiClient.post("/FindUserDetailsById", {
        Request: recipientUserId,
        appSession: {
          ID: 0,
          IsB2C: false,
          TID: 0,
          appid: "ROUNDPAYAPPID13APR20191351",
          id: 0,
          imei: "d593bdd26dfbea56",
          loginTypeID: 1,
          regKey: "",
          serialNo: "d593bdd26dfbea56",
          session: getCookie("session") || "",
          sessionID: getCookie("sessionID") || "",
          uid: 0,
          userID: userData.userID || "",
          version: "1.0",
        },
      });

      if (res.statuscode == 1) {
        setTransferToUserRecipientName(res.name || "");
        setTransferToUserRecipientNotFound(false);
      } else {
        setTransferToUserRecipientName("");
        setTransferToUserRecipientNotFound(true);
      }
    } catch (err) {
      console.log("error", err);
      setTransferToUserRecipientName("");
      setTransferToUserRecipientNotFound(true);
    } finally {
      setIsTransferToUserRecipientLoading(false);
    }
  };

  useEffect(() => {
    if (!String(transferToUserRecipientId).trim()) {
      setTransferToUserRecipientName("");
      setTransferToUserRecipientNotFound(false);
      return;
    }

    const timer = setTimeout(() => {
      fetchTransferToUserRecipient(String(transferToUserRecipientId));
    }, 500);

    return () => clearTimeout(timer);
  }, [transferToUserRecipientId]);

  async function handleTransferToUserSubmit() {
    if (!String(transferToUserRecipientId).trim()) {
      toast.error("Please enter the recipient's User ID");
      return;
    }
    if (isTransferToUserRecipientLoading) {
      toast.error("Please wait, verifying recipient...");
      return;
    }
    if (transferToUserRecipientNotFound || !transferToUserRecipientName) {
      toast.error("Recipient User ID could not be verified");
      return;
    }

    const amount = Number(transferToUserAmount);
    if (!transferToUserAmount || isNaN(amount) || amount <= 0) {
      toast.error("Please enter a valid transfer amount");
      return;
    }
    if (amount > (activeTransferToUserWallet?.balance || 0)) {
      toast.error(
        `Insufficient ${activeTransferToUserWallet?.walletType} Wallet balance`,
      );
      return;
    }

    setIsTransferToUserSubmitting(true);
    try {
      const userData = JSON.parse(getCookie("userData") || "{}");

      const res = await apiClient.post("/WalletToWalletTransfer", {
        appSession: {
          ID: 0,
          IsB2C: false,
          TID: 0,
          appid: "ROUNDPAYAPPID13APR20191351",
          id: 0,
          imei: "d593bdd26dfbea56",
          loginTypeID: 1,
          regKey: "",
          serialNo: "d593bdd26dfbea56",
          session: getCookie("session") || "",
          sessionID: getCookie("sessionID") || "",
          uid: 0,
          userID: userData.userID || "",
          version: "1.0",
        },
        request: {
          FromCurrAmount: transferToUserAmount,
          FromUserId: userData.userID || "",
          FromWalletId: activeTransferToUserWallet?.id,
          IsRecent: false,
          Remark: transferToUserRemark,
          ToUserId: transferToUserRecipientId,
          ToWalletId: activeTransferToUserWallet?.id,
        },
      });

      if (res.statuscode == 1) {
        toast.success(res.msg);
        closeTranferToUserModal();
        fetchBalanceData();
        fetchTransactionHistory(true);
      } else {
        toast.error(res.msg);
      }
    } catch (err) {
      console.log("error", err);
      toast.error("Transfer failed. Please try again.");
    } finally {
      setIsTransferToUserSubmitting(false);
    }
  }

  async function handleTransferSubmit() {
    if (!String(transferToUserId).trim()) {
      toast.error("Please enter the recipient's User ID");
      return;
    }
    if (isRecipientLoading) {
      toast.error("Please wait, verifying recipient...");
      return;
    }
    if (recipientNotFound || !recipientName) {
      toast.error("Recipient User ID could not be verified");
      return;
    }

    const amount = Number(transferAmount);
    if (!transferAmount || isNaN(amount) || amount <= 0) {
      toast.error("Please enter a valid transfer amount");
      return;
    }
    if (
      activeTransferWallet?.minTransferAmount > 0 &&
      amount < activeTransferWallet.minTransferAmount
    ) {
      toast.error(
        `Minimum transfer amount is ${formatAmount(activeTransferWallet.minTransferAmount)}`,
      );
      return;
    }
    if (
      activeTransferWallet?.maxTransferAmount > 0 &&
      amount > activeTransferWallet.maxTransferAmount
    ) {
      toast.error(
        `Maximum transfer amount is ${formatAmount(activeTransferWallet.maxTransferAmount)}`,
      );
      return;
    }
    if (amount > (activeTransferWallet?.balance || 0)) {
      toast.error(
        `Insufficient ${activeTransferWallet?.walletType} Wallet balance`,
      );
      return;
    }

    setIsTransferSubmitting(true);
    try {
      const userData = JSON.parse(getCookie("userData") || "{}");

      const res = await apiClient.post("/WalletToWalletTransfer", {
        appSession: {
          ID: 0,
          IsB2C: false,
          TID: 0,
          appid: "ROUNDPAYAPPID13APR20191351",
          id: 0,
          imei: "d593bdd26dfbea56",
          loginTypeID: 1,
          regKey: "",
          serialNo: "d593bdd26dfbea56",
          session: getCookie("session") || "",
          sessionID: getCookie("sessionID") || "",
          uid: 0,
          userID: userData.userID || "",
          version: "1.0",
        },
        request: {
          FromCurrAmount: transferAmount,
          FromUserId: userData.userID || "",
          FromWalletId: transferAllowedWalletInfo?.fromWallet,
          IsRecent: false,
          Remark: transferRemark,
          ToUserId: transferToUserId,
          ToWalletId: transferAllowedWalletInfo?.toWalletId,
        },
      });

      if (res.statuscode == 1) {
        toast.success(res.msg );
        closeTransferModal();
        fetchBalanceData();
        fetchTransactionHistory(true);
      } else {
        toast.error(res.msg);
      }
    } catch (err) {
      console.log("error", err);
      toast.error("Transfer failed. Please try again.");
    } finally {
      setIsTransferSubmitting(false);
    }
  }

  const fetchTransactionHistory = async (isRecent = false) => {
    setTxnLoading(true);
    try {
      const userData = JSON.parse(getCookie("userData") || "{}");

      const res = await apiClient.post("/App/WalletToWalletReport", {
        appSession: {
          appid: "ROUNDPAYAPPID13APR20191351",
          imei: "d593bdd26dfbea56",
          loginTypeID: "1",
          regKey: "",
          serialNo: "d593bdd26dfbea56",
          version: "1.0",
          uid: 0,
          session: getCookie("session") || "",
          sessionID: getCookie("sessionID") || "",
          userID: userData.userID || "",
        },
        Request: {
          FromDate: formatDateForApi(txnFromDate),
          ToDate: formatDateForApi(txnToDate),
          IsRecent: isRecent,
        },
      });

      if (res.statuscode == 1) {
        setTransactionHistoryData(res);
      } else {
        setTransactionHistoryData({ data: [] });
        toast.error(res.msg || "No data found");
      }
    } catch (err) {
      console.log("error", err);
    } finally {
      setTxnLoading(false);
    }
  };

  function handleTxnSearch() {
    setTxnPage(1);
    fetchTransactionHistory(false);
  }

  function handleTxnReset() {
    setTxnFromDate("");
    setTxnToDate("");
    setTxnPage(1);
    fetchTransactionHistory(true);
  }

  const transactionRows = isTransactionHistoryData?.data || [];
  const transactionPaginated = transactionRows.slice(
    (txnPage - 1) * PAGE_SIZE,
    txnPage * PAGE_SIZE,
  );

  const fetchOperatorList = async () => {
    try {
      const res = await apiClient.post("/App/GetOperators", {
        appid: "ROUNDPAYAPPID13APR20191351",
        imei: "d593bdd26dfbea56",
        regKey: "",
        serialNo: "d593bdd26dfbea56",
        version: "1.0",
      });

      if (res.statuscode == 1) {
        setOperatorList(res.operators || []);
      } else {
        setOperatorList([]);
      }
    } catch (err) {
      console.log("error", err);
    }
  };

  const fetchBankList = async () => {
    const userData = JSON.parse(getCookie("userData") || "{}");
    try {
      const res = await apiClient.post("/App/GetSettlementAccount", {
        ID: 0,
        IsB2C: false,
        TID: 0,
        appid: "ROUNDPAYAPPID13APR20191351",
        id: 0,
        imei: "d593bdd26dfbea56",
        loginTypeID: 1,
        regKey: "",
        serialNo: "d593bdd26dfbea56",
        session: getCookie("session") || "",
        sessionID: getCookie("sessionID") || "",
        uid: 0,
        userID: userData.userID || "",
        version: "1.0",
      });

      if (res.statuscode == 1) {
        setBankAccounts(res.data || []);
      } else {
        setBankAccounts([]);
      }
    } catch (err) {
      console.log("error", err);
    }
  };

  const ChooseBankOptionsToSave = async () => {
    const userData = JSON.parse(getCookie("userData") || "{}");
    try {
      const res = await apiClient.post("/App/GetBankList", {
        paymentID: 0,
        ID: 0,
        IsB2C: false,
        TID: 0,
        appid: "ROUNDPAYAPPID13APR20191351",
        id: 0,
        imei: "d593bdd26dfbea56",
        loginTypeID: 1,
        regKey: "",
        serialNo: "d593bdd26dfbea56",
        session: getCookie("session") || "",
        sessionID: getCookie("sessionID") || "",
        uid: 0,
        userID: userData.userID || "",
        version: "1.0",
      });

      if (res.statuscode == 1) {
        setBankMasterList(res.bankMasters || []);
      } else {
        setBankMasterList([]);
      }
    } catch (err) {
      console.log("error", err);
    }
  };

  const AddBankList = async () => {
    setIsAddingBank(true);
    const userData = JSON.parse(getCookie("userData") || "{}");
    try {
      const res = await apiClient.post("/App/UpdateSettlementAccount", {
        AccountHolder: settlementAccountHolderName,
        AccountNumber: settlementAccountNumber,
        AccountOTP: "",
        BankID: settlementBankId,
        BankName: settlementBank,
        ReferenceID: 0,
        UpdateID: 0,
        ifsc: settlementIfsc,
        ID: 0,
        IsB2C: false,
        TID: 0,
        appid: "ROUNDPAYAPPID13APR20191351",
        id: 0,
        imei: "d593bdd26dfbea56",
        loginTypeID: 1,
        regKey: "",
        serialNo: "d593bdd26dfbea56",
        session: getCookie("session") || "",
        sessionID: getCookie("sessionID") || "",
        uid: 0,
        userID: userData.userID || "",
        version: "1.0",
      });

      if (res.statuscode == 1) {
        toast.success(res.msg);
        setSettlementIfsc("");
        setSettlementBank("");
        setSettlementBankId("");
        setSettlementBranchName("");
        setSettlementAccountNumber("");
        setSettlementAccountHolderName("");
        fetchBankList();
      } else {
        toast.error(res.msg);
      }
    } catch (err) {
      console.log("error", err);
      toast.error("Failed to add bank account. Please try again.");
    } finally {
      setIsAddingBank(false);
    }
  };

  const deleteBankList = async (accountId) => {
    setIsDeletingBank(true);
    const userData = JSON.parse(getCookie("userData") || "{}");
    try {
      const res = await apiClient.post("/App/DeleteSettlementAcount", {
        loginTypeID: 1,
        appid: "ROUNDPAYAPPID13APR20191351",
        imei: "d593bdd26dfbea56",
        regKey: "",
        version: "1.0",
        serialNo: "d593bdd26dfbea56",
        session: getCookie("session") || "",
        sessionID: getCookie("sessionID") || "",
        userID: userData.userID || "",
        UpdateID: accountId,
      });

      if (res.statuscode == 1) {
        toast.success(res.msg);
        fetchBankList();
      } else {
        toast.error(res.msg);
      }
    } catch (err) {
      console.log("error", err);
    } finally {
      setIsDeletingBank(false);
      setAccountPendingDelete(null);
    }
  };

  const TransferMoney = async () => {
    setIsTransferringMoney(true);
    const userData = JSON.parse(getCookie("userData") || "{}");
    try {
      const res = await apiClient.post("/App/BankTranferServiceMLM", {
        Amount: payoutAmount,
        BankId: payoutBankAccount,
        OID: selectedPayoutOperator?.oid,
        WalletID: activePayoutWallet?.id,
        appSession: {
          ID: 0,
          IsB2C: false,
          TID: 0,
          appid: "ROUNDPAYAPPID13APR20191351",
          id: 0,
          imei: "d593bdd26dfbea56",
          loginTypeID: 1,
          regKey: "",
          serialNo: "d593bdd26dfbea56",
          session: getCookie("session") || "",
          sessionID: getCookie("sessionID") || "",
          uid: 0,
          userID: userData.userID || "",
          version: "1.0",
        },
        request: {
          Amount: payoutAmount,
          BankId: payoutBankAccount,
          OID: selectedPayoutOperator?.oid,
          WalletID: activePayoutWallet?.id,
        },
      });

      if (res.statuscode == 2 || res.statuscode == 5) {
        toast.success(res.msg);
        closePayoutModal();
        fetchBalanceData();
        fetchTransactionHistory(true);
      } else {
        toast.error(res.msg);
      }
    } catch (err) {
      console.log("error", err);
      toast.error("Withdrawal request failed. Please try again.");
    } finally {
      setIsTransferringMoney(false);
    }
  };

  function handlePayoutSubmit() {
    if (!payoutBankAccount) {
      toast.error("Please select a bank account");
      return;
    }
    const amount = Number(payoutAmount);
    if (!payoutAmount || isNaN(amount) || amount <= 0) {
      toast.error("Please enter a valid transfer amount");
      return;
    }
    if (!selectedPayoutOperator) {
      toast.error("Please select a valid mode");
      return;
    }
    TransferMoney();
  }

  function handleSaveBank() {
    if (!String(settlementIfsc).trim()) {
      toast.error("Please enter the IFSC code");
      return;
    }
    if (!String(settlementAccountNumber).trim()) {
      toast.error("Please enter the account number");
      return;
    }
    if (!String(settlementAccountHolderName).trim()) {
      toast.error("Please enter the account holder name");
      return;
    }
    AddBankList();
  }

  return (
    <>
      <div className="content">
        <section className="page active" id="page-wallet">
          <div
            id="walletLocked"
            className="content-lock"
            style={{ display: isAccountActive ? "none" : "flex" }}
          >
            <div className="icon-circle">
              <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
              >
                <rect x={4} y={10} width={16} height={10} rx={2} />
                <path d="M8 10V7a4 4 0 018 0v3" />
              </svg>
            </div>
            <h3>Wallets are locked</h3>
            <p>
              Activate your account to start earning affiliate sponsor income
              and manage your wallets.
            </p>
            <button
              className="btn-primary"
              style={{ width: "auto", padding: "11px 22px" }}
              onClick={() => navigate("/panel/activate_package")}
            >
              Activate Now
            </button>
          </div>
          <div
            id="walletUnlocked"
            style={{ display: isAccountActive ? "block" : "none" }}
          >
            <div className="grid grid-2">
              {activeWallets.map((wallet, idx) => {
                const selfTransferTarget = getSelfTransferTarget(wallet);
                const realtimeBankInfo = getRealtimeBankInfo(wallet);
                const walletToWalletInfo =
                  wallet.walletType === "Affiliate"
                    ? null
                    : getWalletToWalletInfo(wallet);
                const btnClass =
                  idx === 0 ? "btn-sm primary" : "btn-sm custom-greenbtn";
                return (
                  <div
                    className={`wallet-card ${idx === 0 ? "affiliate" : "withdrawal"}`}
                    key={wallet.id}
                  >
                    <div className="wallet-label">{wallet.walletType} Wallet</div>
                    <div className="wallet-amount">
                      {formatAmount(wallet.balance)}
                    </div>
                    <div className="wallet-sub">
                      {WALLET_SUBTEXT[wallet.walletType] || ""}
                    </div>
                    {(selfTransferTarget ||
                      realtimeBankInfo ||
                      walletToWalletInfo) && (
                      <div className="cus-walletactions">
                        {selfTransferTarget && (
                          <div className="wallet-actions">
                            <button
                              className={btnClass}
                              onClick={() => openTransferModal(wallet)}
                            >
                              Transfer to {selfTransferTarget.walletName}
                            </button>
                          </div>
                        )}
                        {realtimeBankInfo && (
                          <div className="wallet-actions">
                            <button
                              className={btnClass}
                              onClick={() => openPayoutModal(wallet)}
                            >
                              Request Withdrawal
                            </button>
                          </div>
                        )}
                        {walletToWalletInfo && (
                          <div className="wallet-actions">
                            <button
                              className={btnClass}
                              onClick={() => openTranferToUserModal(wallet)}
                            >
                              Transfer To User
                            </button>
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
            <div className="info-strip">
              <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
              >
                <circle cx={12} cy={12} r={10} />
                <path d="M12 16v-4M12 8h.01" />
              </svg>
              <div>
                When you transfer from your Affiliate Wallet, <b>50%</b> goes to
                your Withdrawal Wallet and <b>50%</b> is credited to your
                sponsor's Affiliate Wallet. Any amount not transferred manually
                moves to your Withdrawal Wallet automatically once a week.
              </div>
            </div>
            <h3 className="section-title">Transaction History</h3>
            <div className="filters-row">
              <div className="field">
                <label>From Date</label>
                <input
                  type="date"
                  value={txnFromDate}
                  onChange={(e) => setTxnFromDate(e.target.value)}
                />
              </div>
              <div className="field">
                <label>To Date</label>
                <input
                  type="date"
                  value={txnToDate}
                  onChange={(e) => setTxnToDate(e.target.value)}
                />
              </div>

              <div className="field field-54854 cus-field-845">
                <button className="btn-sm primary" onClick={handleTxnSearch}>
                  Search
                </button>
              </div>

              <div className="field field-54854">
                <button className="btn-sm" onClick={handleTxnReset}>
                  Reset
                </button>
              </div>
            </div>
            <div className="card">
              <div className="table-scroll">
                <table>
                  <thead>
                    <tr>
                      <th>S.No</th>
                      <th>Transaction Id</th>
                      <th>From User</th>
                      <th>To User</th>
                      <th>Wallet</th>
                      <th>Type</th>
                      <th>Amount</th>
                      <th>Date</th>
                    </tr>
                  </thead>
                  <tbody>
                    {isTxnLoading ? (
                      <tr>
                        <td colSpan={6} className="table-empty">
                          Loading transaction history...
                        </td>
                      </tr>
                    ) : transactionRows.length === 0 ? (
                      <tr>
                        <td colSpan={6} className="table-empty">
                          No transactions found.
                        </td>
                      </tr>
                    ) : (
                      transactionPaginated.map((txn, idx) => (
                        <tr key={txn.tid}>
                          <td className="mono">
                            {(txnPage - 1) * PAGE_SIZE + idx + 1}
                          </td>
                          <td>{txn.tid || "-"}</td>
                          <td>
                            {txn.fromUserName || "-"}
                            <br />[{txn.prefix}
                            {txn.fromUserId}]
                          </td>
                          <td>
                            {txn.toUserName || "-"}
                            <br />[{txn.prefix}
                            {txn.toUserId}]
                          </td>
                          <td className="strong">Wallet Transfer</td>
                          <td>
                            {txn.fromWalletName} → {txn.toWalletName}
                          </td>
                          <td className="mono">
                            {formatAmount(txn.fromCurrAmount)}
                          </td>
                          <td>{txn.entryDate || "-"}</td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>
              <Pagination
                currentPage={txnPage}
                totalItems={transactionRows.length}
                pageSize={PAGE_SIZE}
                onPageChange={setTxnPage}
              />
            </div>
          </div>
        </section>
      </div>

      {isTransferModalOpen && (
        <div className="modal-overlay active">
          <div className="modal md">
            <span className="modal-close" onClick={closeTransferModal}>
              &times;
            </span>

            <div className="modal-head">
              <h3>{transferServiceInfo?.serviceName}</h3>
            </div>

            <div className="grid grid-2">
              <div className="field">
                <label>From Wallet</label>
                <select
                  value={transferAllowedWalletInfo?.fromWalletName || ""}
                  disabled
                >
                  <option>{transferAllowedWalletInfo?.fromWalletName}</option>
                </select>
              </div>
              <div className="field">
                <label>To Wallet</label>
                <select
                  value={transferAllowedWalletInfo?.walletName || ""}
                  disabled
                >
                  <option>{transferAllowedWalletInfo?.walletName}</option>
                </select>
              </div>
            </div>

            <div className="grid grid-2">
              <div className="field">
                <label>User Id</label>
                <input
                  type="text"
                  placeholder="Recipient's User ID"
                  value={transferToUserId}
                  onChange={(e) => setTransferToUserId(e.target.value)}
                  disabled={transferIsSelfTransfer}
                />
                {isRecipientLoading && (
                  <div
                    className="field-note"
                    style={{ color: "var(--text-faint)" }}
                  >
                    Verifying...
                  </div>
                )}
                {!isRecipientLoading && recipientName && (
                  <div className="field-note">{recipientName}</div>
                )}
                {!isRecipientLoading && recipientNotFound && (
                  <div className="field-note" style={{ color: "var(--red)" }}>
                    User not found
                  </div>
                )}
              </div>
              <div className="field">
                <label>Transaction Amount</label>
                <input
                  type="number"
                  placeholder="Enter amount"
                  value={transferAmount}
                  onChange={(e) => setTransferAmount(e.target.value)}
                />
              </div>
            </div>

            <div className="field">
              <label>Remark</label>
              <textarea
                placeholder="Add a remark (optional)"
                value={transferRemark}
                onChange={(e) => setTransferRemark(e.target.value)}
              />
            </div>

            <div
              style={{ display: "flex", justifyContent: "flex-end", gap: 10 }}
            >
              <button
                type="button"
                className="btn-sm"
                style={{ width: "auto", padding: "10px 26px" }}
                onClick={closeTransferModal}
                disabled={isTransferSubmitting}
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn-primary btn-primary-top-2"
                style={{ width: "auto", padding: "10px 26px" }}
                onClick={handleTransferSubmit}
                disabled={isTransferSubmitting}
              >
                {isTransferSubmitting ? "Submitting..." : "Submit"}
              </button>
            </div>
          </div>
        </div>
      )}

      {isTransferToUserModalOpen && (
        <div className="modal-overlay active">
          <div className="modal md">
            <span className="modal-close" onClick={closeTranferToUserModal}>
              &times;
            </span>

            <div className="modal-head">
              <h3>{transferToUserServiceInfo?.serviceName}</h3>
            </div>

            <div className="grid grid-2">
              <div className="field">
                <label>From Wallet</label>
                <select
                  value={activeTransferToUserWallet?.walletType || ""}
                  disabled
                >
                  <option>{activeTransferToUserWallet?.walletType}</option>
                </select>
              </div>
              <div className="field">
                <label>To Wallet</label>
                <select
                  value={activeTransferToUserWallet?.walletType || ""}
                  disabled
                >
                  <option>{activeTransferToUserWallet?.walletType}</option>
                </select>
              </div>
            </div>

            <div className="grid grid-2">
              <div className="field">
                <label>User Id</label>
                <input
                  type="text"
                  placeholder="Recipient's User ID"
                  value={transferToUserRecipientId}
                  onChange={(e) =>
                    setTransferToUserRecipientId(e.target.value)
                  }
                />
                {isTransferToUserRecipientLoading && (
                  <div
                    className="field-note"
                    style={{ color: "var(--text-faint)" }}
                  >
                    Verifying...
                  </div>
                )}
                {!isTransferToUserRecipientLoading &&
                  transferToUserRecipientName && (
                    <div className="field-note">
                      {transferToUserRecipientName}
                    </div>
                  )}
                {!isTransferToUserRecipientLoading &&
                  transferToUserRecipientNotFound && (
                    <div
                      className="field-note"
                      style={{ color: "var(--red)" }}
                    >
                      User not found
                    </div>
                  )}
              </div>
              <div className="field">
                <label>Transaction Amount</label>
                <input
                  type="number"
                  placeholder="Enter amount"
                  value={transferToUserAmount}
                  onChange={(e) => setTransferToUserAmount(e.target.value)}
                />
              </div>
            </div>

            <div className="field">
              <label>Remark</label>
              <textarea
                placeholder="Add a remark (optional)"
                value={transferToUserRemark}
                onChange={(e) => setTransferToUserRemark(e.target.value)}
              />
            </div>

            <div
              style={{ display: "flex", justifyContent: "flex-end", gap: 10 }}
            >
              <button
                type="button"
                className="btn-sm"
                style={{ width: "auto", padding: "10px 26px" }}
                onClick={closeTranferToUserModal}
                disabled={isTransferToUserSubmitting}
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn-primary btn-primary-top-2"
                style={{ width: "auto", padding: "10px 26px" }}
                onClick={handleTransferToUserSubmit}
                disabled={isTransferToUserSubmitting}
              >
                {isTransferToUserSubmitting ? "Submitting..." : "Submit"}
              </button>
            </div>
          </div>
        </div>
      )}

      {isPayoutModalOpen && (
        <div className="modal-overlay active">
          <div className="modal md">
            <span className="modal-close" onClick={closePayoutModal}>
              &times;
            </span>

            <div className="modal-head">
              <h3>{payoutServiceInfo?.serviceName}</h3>
            </div>

            <div className="field">
              <label>From Wallet</label>
              <select value={payoutServiceInfo?.walletName || ""} disabled>
                <option>{payoutServiceInfo?.walletName}</option>
              </select>
              <div className="field-note" style={{ color: "var(--text-dim)" }}>
                Wallet Balance: {formatAmount(activePayoutWallet?.balance)}
              </div>
            </div>

            <div className="field">
              <label>Bank Account</label>
              <div style={{ display: "flex", gap: 10 }}>
                <select
                  style={{ flex: 1 }}
                  value={payoutBankAccount}
                  onChange={(e) => setPayoutBankAccount(e.target.value)}
                >
                  <option value="">Select Bank Account</option>
                  {bankAccounts.map((acc) => (
                    <option key={acc.id} value={acc.id}>
                      {acc.bankName} - {acc.accountNumber}
                    </option>
                  ))}
                </select>
                <button
                  type="button"
                  className="btn-sm primary"
                  onClick={openSettlementModal}
                >
                  Add Bank
                </button>
              </div>
            </div>

            <div className="field">
              <label>Transfer Amount</label>
              <div style={{ display: "flex", gap: 10 }}>
                <input
                  style={{ flex: 1 }}
                  type="number"
                  placeholder="Enter amount"
                  value={payoutAmount}
                  onChange={(e) => setPayoutAmount(e.target.value)}
                />
              </div>
            </div>

            <div className="field">
              <label>Mode</label>
              <select
                value={payoutMode}
                onChange={(e) => setPayoutMode(e.target.value)}
              >
                {payoutModes.length === 0 ? (
                  <option value="">No modes available</option>
                ) : (
                  payoutModes.map((mode) => (
                    <option key={mode.oid} value={mode.name}>
                      {mode.name}
                    </option>
                  ))
                )}
              </select>
            </div>

            <div
              style={{ display: "flex", justifyContent: "flex-end", gap: 10 }}
            >
              <button
                type="button"
                className="btn-sm"
                style={{ width: "auto", padding: "10px 26px" }}
                onClick={closePayoutModal}
                disabled={isTransferringMoney}
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn-primary btn-primary-top-2"
                style={{ width: "auto", padding: "10px 26px" }}
                onClick={handlePayoutSubmit}
                disabled={isTransferringMoney}
              >
                {isTransferringMoney ? "Transferring..." : "Transfer"}
              </button>
            </div>
          </div>
        </div>
      )}

      {isSettlementModalOpen && (
        <div className="modal-overlay active">
          <div className="modal wide">
            <span className="modal-close" onClick={closeSettlementModal}>
              &times;
            </span>

            <div className="modal-head">
              <h3>Settlement Account</h3>
            </div>

            <div className="grid grid-2">
              <div className="field">
                <label>IFSC</label>
                <input
                  type="text"
                  placeholder="Enter IFSC Code"
                  value={settlementIfsc}
                  onChange={(e) => setSettlementIfsc(e.target.value)}
                />
              </div>
              <div className="field">
                <label>Bank</label>
                <input
                  type="text"
                  list="bank-master-options"
                  placeholder="Search or select a bank"
                  value={settlementBank}
                  onChange={(e) => {
                    const typedName = e.target.value;
                    setSettlementBank(typedName);
                    const matchedBank = bankMasterList.find(
                      (bank) => bank.bankName === typedName,
                    );
                    setSettlementBankId(matchedBank ? matchedBank.id : "");
                  }}
                />
                <datalist id="bank-master-options">
                  {bankMasterList.map((bank) => (
                    <option key={bank.id} value={bank.bankName} />
                  ))}
                </datalist>
              </div>
            </div>

            <div className="grid grid-2">
              <div className="field">
                <label>Branch Name</label>
                <input
                  type="text"
                  placeholder="Branch Name"
                  value={settlementBranchName}
                  onChange={(e) => setSettlementBranchName(e.target.value)}
                />
              </div>
              <div className="field">
                <label>Account Number</label>
                <input
                  type="text"
                  placeholder="Enter Account Number"
                  value={settlementAccountNumber}
                  onChange={(e) => setSettlementAccountNumber(e.target.value)}
                />
              </div>
            </div>

            <div className="field">
              <label>Account Holder Name</label>
              <div style={{ display: "flex", gap: 10 }}>
                <input
                  style={{ flex: 1 }}
                  type="text"
                  placeholder="Enter Account Name"
                  value={settlementAccountHolderName}
                  onChange={(e) =>
                    setSettlementAccountHolderName(e.target.value)
                  }
                />
                <button
                  type="button"
                  className="btn-sm primary"
                  onClick={handleSaveBank}
                  disabled={isAddingBank}
                >
                  {isAddingBank ? "Saving..." : "Save"}
                </button>
              </div>
              <div
                className="field-note"
                style={{ color: "var(--text-faint)" }}
              >
                (Verify IFSC Code before saving.)
              </div>
            </div>

            <div className="table-scroll" style={{ marginTop: 10 }}>
              <table>
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Bank Name</th>
                    <th>Account Number</th>
                    <th>Account Holder Name</th>
                    <th>IFSC</th>
                    <th>Approval Status</th>
                    <th>Default</th>
                    <th>Delete</th>
                  </tr>
                </thead>
                <tbody>
                  {bankAccounts.length === 0 ? (
                    <tr>
                      <td colSpan={8} className="table-empty">
                        No bank accounts added yet.
                      </td>
                    </tr>
                  ) : (
                    bankAccounts.map((acc, idx) => {
                      const approvalLabel = acc.approvalText || "-";
                      const approvalBadgeClass =
                        approvalLabel.toLowerCase() === "approved"
                          ? "green"
                          : approvalLabel.toLowerCase() === "rejected"
                            ? "red"
                            : "gold";
                      return (
                        <tr key={acc.id ?? idx}>
                          <td className="mono">{idx + 1}</td>
                          <td className="strong">{acc.bankName}</td>
                          <td className="mono">{acc.accountNumber}</td>
                          <td>{acc.accountHolder}</td>
                          <td className="mono">{acc.ifsc}</td>
                          <td>
                            <span className={`badge ${approvalBadgeClass}`}>
                              {approvalLabel}
                            </span>
                          </td>
                          <td>
                            <div
                              className={`switch${acc.isDefault ? " on" : ""}`}
                            >
                              <div className="knob" />
                            </div>
                          </td>
                          <td>
                            <button
                              type="button"
                              className="btn-sm"
                              onClick={() => setAccountPendingDelete(acc)}
                              disabled={isDeletingBank}
                            >
                              Delete
                            </button>
                          </td>
                        </tr>
                      );
                    })
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}

      {accountPendingDelete && (
        <div
          className="modal-overlay active"
          onClick={() => setAccountPendingDelete(null)}
        >
          <div className="modal" onClick={(e) => e.stopPropagation()}>
            <span
              className="modal-close"
              onClick={() => setAccountPendingDelete(null)}
            >
              &times;
            </span>
            <h3>Delete Bank Account</h3>
            <p style={{ color: "var(--text-dim)", fontSize: 13.5 }}>
              Are you sure you want to delete{" "}
              <b style={{ color: "var(--text)" }}>
                {accountPendingDelete.bankName}
              </b>{" "}
              - {accountPendingDelete.accountNumber}? This cannot be undone.
            </p>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                gap: 10,
                marginTop: 20,
              }}
            >
              <button
                type="button"
                className="btn-sm btn-sm-modal"
                onClick={() => setAccountPendingDelete(null)}
                disabled={isDeletingBank}
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn-primary"
                style={{
                  width: "auto",
                  padding: "10px 22px",
                  background: "var(--red)",
                }}
                onClick={() => deleteBankList(accountPendingDelete.id)}
                disabled={isDeletingBank}
              >
                {isDeletingBank ? "Deleting..." : "Delete"}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
